import { Box } from '@mui/material';
import { PublicShareInfoText, SectionTitle } from './styles';
import { JobViewPublicShareLinkProps } from '../types';
import { CopyLinkInput } from 'sharedComponents/CopyLinkInput';

export const JobViewPublicShareLink: React.FC<JobViewPublicShareLinkProps> = ({
  dataTestId,
  link,
  sx,
}) => {
  return (
    <Box data-testid={dataTestId || 'public-share-link-section'} sx={sx}>
      <SectionTitle variant="h2">Public share link</SectionTitle>
      <PublicShareInfoText data-testid="public-share-info">
        This link will take users to the publicly available listing for this role. They don&apos;t
        need a Nimble account to access.
      </PublicShareInfoText>
      <CopyLinkInput
        link={link}
        linkDataTestId="job-link"
        copyButtonDataTestId="copy-to-clipboard-button"
        maxWidth="100%"
      />
    </Box>
  );
};
